
function JuryController(clickCallback) {

	//setup the FAQ buttons
	$('.details a').each( function(i) {

		$(this).on('click', function() {

			//_gaq.push(['_trackEvent', 'Jury', 'Bio', 'Toggle', i ]);
      ga('send', 'event',  'Jury', 'Bio', 'Toggle', i );

			$($(this).next()).slideToggle(200);
			$(this).remove();

		});
	});

}

module.exports = JuryController;



// WEBPACK FOOTER //
// ./js/src/JuryController.js